import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Public Guest Page
    findYourSeat: 'Find Your Seat',
    searchPlaceholder: 'Type your name...',
    yourTable: 'Your Table',
    noResults: "We couldn't find that name. Please check with the host or try a different spelling.",
    startTyping: 'Start typing your name to find your table',
    tableInfo: 'Table Info',
    personalNote: 'Personal Note',
    // Share a moment (guest photo upload section)
    yourViewOfTheDay: 'Your view of the day',
    shareAMoment: 'Share a moment',
    shareAnotherMoment: 'Share another moment',
    saveLinkToReturnLater: 'Save this link to return later',
    momentsShared: "You've shared your moments",
    savedForThem: 'Saved for them.',
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    confirmPassword: 'Confirm Password',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    welcome: 'Welcome!',
    welcomeBack: 'Welcome back!',
    passwordsDoNotMatch: 'Passwords do not match. Please check and try again.',
    // Dashboard
    myEvents: 'My Events',
    createEvent: 'Create Event',
    noEvents: 'No events yet. Create your first event!',
    guests: 'guests',
    viewQR: 'View QR',
    manage: 'Manage',
    // Event Setup
    eventDetails: 'Event Details',
    eventName: 'Event Name',
    eventDate: 'Date',
    eventLocation: 'Location',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    // Guests & Tables
    guestList: 'Guest List',
    tables: 'Tables',
    addGuest: 'Add Guest',
    addTable: 'Add Table',
    uploadCSV: 'Upload CSV',
    downloadTemplate: 'CSV Template',
    deleteAllGuests: 'Delete All',
    confirmDeleteAllGuests: 'Are you sure you want to delete ALL guests? This action cannot be undone.',
    allGuestsDeleted: '{count} guests deleted successfully',
    // Delete Event
    confirmDelete: 'Are you sure you want to delete',
    eventDeleted: 'Event deleted successfully',
    deleteError: 'Failed to delete',
    fullName: 'Full Name',
    group: 'Group',
    notes: 'Notes',
    table: 'Table',
    capacity: 'Capacity',
    tableName: 'Table Name',
    tableShape: 'Table Shape',
    searchGuests: 'Search guests...',
    filterByTable: 'Filter by table',
    allTables: 'All Tables',
    noTableAssigned: 'No table assigned',
    // QR Code
    qrCode: 'QR Code',
    downloadQR: 'Download QR Code',
    generateQR: 'Generate QR Code',
    qrGenerated: 'QR Code generated!',
    qrInstructions: 'Download this QR code and place it on your event signage or import it into Canva.',
    publicLink: 'Public Link',
    qrColor: 'QR Code Color',
    customColor: 'Custom',
    noQRGenerated: 'No QR code generated yet',
    applying: 'Applying',
    qrColorPremiumFeature: 'QR code color customization is a premium feature',
    upgradeToPremium: 'Upgrade to Premium',
    // CSV
    csvFormat: 'CSV Format: full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Tip: Uploading updates existing guests (by name) and adds new ones.',
    importSuccess: 'Import successful!',
    // Language
    language: 'Language',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    greek: 'Ελληνικά',
    or: 'or',
    signInWithGoogle: 'Sign in with Google',
    // Actions
    edit: 'Edit',
    back: 'Back',
    logout: 'Logout',
    // Support Contact
    supportContact: 'Support Contact',
    supportSubject: 'Subject',
    supportMessage: 'Message',
    supportSubjectPlaceholder: 'What can we help you with?',
    supportMessagePlaceholder: 'Describe your question or issue in detail...',
    supportSendMessage: 'Send Message',
    supportSending: 'Sending...',
    supportHelpText: "Have a question or need help? Send us a message and we'll get back to you as soon as possible.",
    supportSuccess: 'Support request sent successfully!',
    supportError: 'Failed to send support request',
    supportValidationError: 'Please fill in both subject and message',
    // Upgrade & Pricing
    upgrade: 'Upgrade',
    upgradeEvent: 'Upgrade Event',
    upgradeNow: 'Upgrade Now',
    currentPlan: 'Current Plan',
    current: 'Current',
    tryDaysFree: 'Try {days} Days Free',
    trialActive: 'Trial Active',
    trialUsed: 'Trial used',
    trial: 'Trial',
    viewFullPricing: 'View Full Pricing & Features',
    unlockPremiumFeatures: 'Unlock premium features to make your event unforgettable.',
    chooseYourPlan: 'Choose the plan that fits your needs.',
    // Plan Limit Messages
    planLimitReached: "You've reached your plan's limit. Upgrade to continue.",
    planLimitGuests: "You've reached your guest limit. Upgrade to add more guests.",
    planLimitEventsFree: "You've reached your event limit. Upgrade to Pro for up to 3 events.",
    planLimitEventsPro: "You've reached the maximum of 3 events for Pro tier.",
    haveVoucher: 'Have a voucher code?',
    enterVoucherCode: 'Enter voucher code',
    apply: 'Apply',
    selectPlanFirst: 'Select a plan first to apply voucher',
    voucherApplied: 'Voucher applied!',
    youSave: 'You save',
    featureComparison: 'Feature Comparison',
    feature: 'Feature',
    maximumGuests: 'Maximum Guests',
    unlimited: 'Unlimited',
    colorThemes: 'Color Themes',
    defaultOnly: 'Default only',
    customMessages: 'Custom Messages',
    backgroundImages: 'Background Images',
    customQrColor: 'Custom QR Code Color',
    presetThemes: 'Preset Themes',
    allColorThemes: 'All color themes',
    upToEvents: 'Up to {count} events',
    oneEvent: '1 event',
    tax: 'Tax',
    total: 'Total',
    processing: 'Processing...',
    free: 'Free',
    premium: 'Premium',
    premiumPlus: 'Premium Plus',
    pro: 'Pro',
    freeDescription: 'Basic features for small events',
    premiumDescription: 'All features with unlimited guests',
    proDescription: 'All features with unlimited guests and multiple events',
    // Upgrade Popup
    premiumFeature: 'Premium Feature',
    premiumFeaturesRequired: 'The following features require a paid plan to save:',
    customEventMessage: 'Custom Event Message',
    customColorTheme: 'Custom Color Theme',
    customColorSettings: 'Custom Color Settings',
    upgradeToUnlock: 'Upgrade to unlock these features and make your event stand out!',
    // Forgot Password & Legal
    forgotPassword: 'Forgot your password?',
    bySigningIn: 'By signing in, you agree to our',
    terms: 'Terms',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    // Terms Page
    termsOfService: 'Terms of Service',
    termsLastUpdated: 'Last Updated',
    termsIntro: 'Welcome to Digital Seating Chart. By accessing or using our service, you agree to be bound by these Terms of Service.',
    termsAcceptance: 'Acceptance of Terms',
    termsAcceptanceText: 'By accessing and using Digital Seating Chart, you accept and agree to be bound by the terms and provision of this agreement.',
    termsUseOfService: 'Use of Service',
    termsUseOfServiceText: 'You may use our service for lawful purposes only. You agree not to use the service in any way that violates any applicable laws or regulations.',
    termsUserAccounts: 'User Accounts',
    termsUserAccountsText: 'When you create an account with us, you must provide accurate and complete information. You are responsible for safeguarding your account credentials.',
    termsIntellectualProperty: 'Intellectual Property',
    termsIntellectualPropertyText: 'The service and its original content, features, and functionality are owned by Digital Seating Chart and are protected by international copyright, trademark, and other intellectual property laws.',
    termsTermination: 'Termination',
    termsTerminationText: 'We may terminate or suspend your account immediately, without prior notice or liability, for any reason, including breach of these Terms.',
    termsLimitation: 'Limitation of Liability',
    termsLimitationText: 'In no event shall Digital Seating Chart be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.',
    termsChanges: 'Changes to Terms',
    termsChangesText: 'We reserve the right to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms on this page.',
    termsContact: 'Contact Us',
    termsContactText: 'If you have any questions about these Terms, please contact us.',
    // Privacy Page
    privacyPolicyTitle: 'Privacy Policy',
    privacyLastUpdated: 'Last Updated',
    privacyIntro: 'Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information.',
    privacyDataCollection: 'Information We Collect',
    privacyDataCollectionText: 'We collect information you provide directly, such as your name, email address, and event details. We also collect usage data to improve our service.',
    privacyDataUse: 'How We Use Your Information',
    privacyDataUseText: 'We use your information to provide and improve our services, communicate with you, and ensure the security of our platform.',
    privacyDataSharing: 'Information Sharing',
    privacyDataSharingText: 'We do not sell your personal information. We may share data with service providers who assist us in operating our platform.',
    privacyDataSecurity: 'Data Security',
    privacyDataSecurityText: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, or destruction.',
    privacyUserRights: 'Your Rights',
    privacyUserRightsText: 'You have the right to access, correct, or delete your personal data. You can manage your information through your account settings.',
    privacyCookies: 'Cookies',
    privacyCookiesText: 'We use cookies to enhance your experience. You can control cookie settings through your browser preferences.',
    privacyChanges: 'Changes to This Policy',
    privacyChangesText: 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page.',
    privacyContact: 'Contact Us',
    privacyContactText: 'If you have questions about this Privacy Policy, please contact us.',
  },
  pt: {
    // Public Guest Page — informal pt-PT register ("tu") for guest-facing surfaces
    findYourSeat: 'Encontra o Teu Lugar',
    searchPlaceholder: 'Escreve o teu nome...',
    yourTable: 'A Tua Mesa',
    noResults: 'Não encontrámos esse nome. Por favor, verifica com o anfitrião ou tenta uma grafia diferente.',
    startTyping: 'Começa a escrever o teu nome para encontrar a tua mesa',
    tableInfo: 'Informação da Mesa',
    personalNote: 'Nota Pessoal',
    // Share a moment
    yourViewOfTheDay: 'A tua vista do dia',
    shareAMoment: 'Partilha um momento',
    shareAnotherMoment: 'Partilha outro momento',
    saveLinkToReturnLater: 'Guarda este link para voltar mais tarde',
    momentsShared: 'Partilhaste os teus momentos',
    savedForThem: 'Guardados para eles.',
    // Auth
    login: 'Entrar',
    register: 'Registar',
    email: 'E-mail',
    password: 'Palavra-passe',
    name: 'Nome',
    confirmPassword: 'Confirmar Palavra-passe',
    dontHaveAccount: 'Não tem uma conta?',
    alreadyHaveAccount: 'Já tem uma conta?',
    welcome: 'Bem-vindo!',
    welcomeBack: 'Bem-vindo de volta!',
    passwordsDoNotMatch: 'As palavras-passe não coincidem. Por favor, verifique e tente novamente.',
    // Dashboard
    myEvents: 'Os Meus Eventos',
    createEvent: 'Criar Evento',
    noEvents: 'Ainda não tem eventos. Crie o seu primeiro evento!',
    guests: 'convidados',
    viewQR: 'Ver QR',
    manage: 'Gerir',
    // Event Setup
    eventDetails: 'Detalhes do Evento',
    eventName: 'Nome do Evento',
    eventDate: 'Data',
    eventLocation: 'Local',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    // Guests & Tables
    guestList: 'Lista de Convidados',
    tables: 'Mesas',
    addGuest: 'Adicionar Convidado',
    addTable: 'Adicionar Mesa',
    uploadCSV: 'Importar CSV',
    downloadTemplate: 'Modelo CSV',
    deleteAllGuests: 'Eliminar Todos',
    confirmDeleteAllGuests: 'Tem a certeza que deseja eliminar TODOS os convidados? Esta ação não pode ser revertida.',
    allGuestsDeleted: '{count} convidados eliminados com sucesso',
    // Delete Event
    confirmDelete: 'Tem a certeza que deseja eliminar',
    eventDeleted: 'Evento eliminado com sucesso',
    deleteError: 'Falha ao eliminar',
    fullName: 'Nome Completo',
    group: 'Grupo',
    notes: 'Observações',
    table: 'Mesa',
    capacity: 'Capacidade',
    tableName: 'Nome da Mesa',
    tableShape: 'Formato da Mesa',
    searchGuests: 'Procurar convidados...',
    filterByTable: 'Filtrar por mesa',
    allTables: 'Todas as Mesas',
    noTableAssigned: 'Sem mesa atribuída',
    // QR Code
    qrCode: 'Código QR',
    downloadQR: 'Transferir Código QR',
    generateQR: 'Gerar Código QR',
    qrGenerated: 'Código QR gerado!',
    qrInstructions: 'Transfira este código QR e coloque-o na sinalização do seu evento ou importe-o no Canva.',
    publicLink: 'Ligação Pública',
    qrColor: 'Cor do Código QR',
    customColor: 'Personalizado',
    noQRGenerated: 'Nenhum código QR gerado ainda',
    applying: 'A aplicar',
    qrColorPremiumFeature: 'A personalização da cor do código QR é uma funcionalidade premium',
    upgradeToPremium: 'Atualizar para Premium',
    // CSV
    csvFormat: 'Formato CSV: full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Dica: O carregamento atualiza convidados existentes (por nome) e adiciona novos.',
    importSuccess: 'Importação bem sucedida!',
    // Language
    language: 'Idioma',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    or: 'ou',
    signInWithGoogle: 'Entrar com Google',
    // Actions
    edit: 'Editar',
    back: 'Voltar',
    logout: 'Sair',
    // Support Contact
    supportContact: 'Contacto de Suporte',
    supportSubject: 'Assunto',
    supportMessage: 'Mensagem',
    supportSubjectPlaceholder: 'Como podemos ajudá-lo?',
    supportMessagePlaceholder: 'Descreva a sua pergunta ou problema em detalhe...',
    supportSendMessage: 'Enviar Mensagem',
    supportSending: 'A enviar...',
    supportHelpText: 'Tem alguma pergunta ou precisa de ajuda? Envie-nos uma mensagem e responderemos o mais rapidamente possível.',
    supportSuccess: 'Pedido de suporte enviado com sucesso!',
    supportError: 'Falha ao enviar pedido de suporte',
    supportValidationError: 'Por favor, preencha o assunto e a mensagem',
    // Upgrade & Pricing
    upgrade: 'Atualizar',
    upgradeEvent: 'Atualizar Evento',
    upgradeNow: 'Atualizar Agora',
    currentPlan: 'Plano Atual',
    current: 'Atual',
    tryDaysFree: 'Experimente {days} Dias Grátis',
    trialActive: 'Período de Teste Ativo',
    trialUsed: 'Teste utilizado',
    trial: 'Teste',
    viewFullPricing: 'Ver Preços e Funcionalidades',
    unlockPremiumFeatures: 'Desbloqueie funcionalidades premium para tornar o seu evento inesquecível.',
    chooseYourPlan: 'Escolha o plano que melhor se adapta às suas necessidades.',
    // Plan Limit Messages
    planLimitReached: 'Atingiu o limite do seu plano. Atualize para continuar.',
    planLimitGuests: 'Atingiu o limite de convidados. Atualize para adicionar mais.',
    planLimitEventsFree: 'Atingiu o limite de eventos. Atualize para Pro para até 3 eventos.',
    planLimitEventsPro: 'Atingiu o máximo de 3 eventos para o plano Pro.',
    haveVoucher: 'Tem um código de voucher?',
    enterVoucherCode: 'Introduza o código do voucher',
    apply: 'Aplicar',
    selectPlanFirst: 'Selecione um plano primeiro para aplicar o voucher',
    voucherApplied: 'Voucher aplicado!',
    youSave: 'Poupa',
    featureComparison: 'Comparação de Funcionalidades',
    feature: 'Funcionalidade',
    maximumGuests: 'Máximo de Convidados',
    unlimited: 'Ilimitado',
    colorThemes: 'Temas de Cores',
    defaultOnly: 'Apenas predefinido',
    customMessages: 'Mensagens Personalizadas',
    backgroundImages: 'Imagens de Fundo',
    customQrColor: 'Cor do QR Code Personalizada',
    presetThemes: 'Temas Predefinidos',
    allColorThemes: 'Todos os temas de cores',
    upToEvents: 'Até {count} eventos',
    oneEvent: '1 evento',
    tax: 'Imposto',
    total: 'Total',
    processing: 'A processar...',
    free: 'Gratuito',
    premium: 'Premium',
    premiumPlus: 'Premium Plus',
    pro: 'Pro',
    freeDescription: 'Funcionalidades básicas para pequenos eventos',
    premiumDescription: 'Todas as funcionalidades com convidados ilimitados',
    proDescription: 'Todas as funcionalidades com convidados ilimitados e múltiplos eventos',
    // Upgrade Popup
    premiumFeature: 'Funcionalidade Premium',
    premiumFeaturesRequired: 'As seguintes funcionalidades requerem um plano pago para guardar:',
    customEventMessage: 'Mensagem de Evento Personalizada',
    customColorTheme: 'Tema de Cores Personalizado',
    customColorSettings: 'Definições de Cores Personalizadas',
    upgradeToUnlock: 'Atualize para desbloquear estas funcionalidades e destacar o seu evento!',
    // Forgot Password & Legal
    forgotPassword: 'Esqueceu-se da palavra-passe?',
    bySigningIn: 'Ao entrar, concorda com os nossos',
    terms: 'Termos',
    and: 'e',
    privacyPolicy: 'Política de Privacidade',
    // Terms Page
    termsOfService: 'Termos de Serviço',
    termsLastUpdated: 'Última Atualização',
    termsIntro: 'Bem-vindo ao Digital Seating Chart. Ao aceder ou utilizar o nosso serviço, concorda em ficar vinculado a estes Termos de Serviço.',
    termsAcceptance: 'Aceitação dos Termos',
    termsAcceptanceText: 'Ao aceder e utilizar o Digital Seating Chart, aceita e concorda em ficar vinculado aos termos e disposições deste acordo.',
    termsUseOfService: 'Utilização do Serviço',
    termsUseOfServiceText: 'Pode utilizar o nosso serviço apenas para fins legais. Concorda em não utilizar o serviço de forma que viole quaisquer leis ou regulamentos aplicáveis.',
    termsUserAccounts: 'Contas de Utilizador',
    termsUserAccountsText: 'Ao criar uma conta connosco, deve fornecer informações precisas e completas. É responsável por proteger as credenciais da sua conta.',
    termsIntellectualProperty: 'Propriedade Intelectual',
    termsIntellectualPropertyText: 'O serviço e o seu conteúdo original, funcionalidades e características são propriedade do Digital Seating Chart e são protegidos por leis internacionais de direitos de autor, marcas registadas e outras leis de propriedade intelectual.',
    termsTermination: 'Rescisão',
    termsTerminationText: 'Podemos encerrar ou suspender a sua conta imediatamente, sem aviso prévio ou responsabilidade, por qualquer motivo, incluindo violação destes Termos.',
    termsLimitation: 'Limitação de Responsabilidade',
    termsLimitationText: 'Em caso algum o Digital Seating Chart será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos resultantes da sua utilização do serviço.',
    termsChanges: 'Alterações aos Termos',
    termsChangesText: 'Reservamo-nos o direito de modificar ou substituir estes Termos a qualquer momento. Notificá-lo-emos sobre quaisquer alterações publicando os novos Termos nesta página.',
    termsContact: 'Contacte-nos',
    termsContactText: 'Se tiver alguma dúvida sobre estes Termos, por favor contacte-nos.',
    // Privacy Page
    privacyPolicyTitle: 'Política de Privacidade',
    privacyLastUpdated: 'Última Atualização',
    privacyIntro: 'A sua privacidade é importante para nós. Esta Política de Privacidade explica como recolhemos, utilizamos e protegemos as suas informações.',
    privacyDataCollection: 'Informações que Recolhemos',
    privacyDataCollectionText: 'Recolhemos informações que fornece diretamente, como o seu nome, endereço de e-mail e detalhes do evento. Também recolhemos dados de utilização para melhorar o nosso serviço.',
    privacyDataUse: 'Como Utilizamos as Suas Informações',
    privacyDataUseText: 'Utilizamos as suas informações para fornecer e melhorar os nossos serviços, comunicar consigo e garantir a segurança da nossa plataforma.',
    privacyDataSharing: 'Partilha de Informações',
    privacyDataSharingText: 'Não vendemos as suas informações pessoais. Podemos partilhar dados com fornecedores de serviços que nos auxiliam na operação da nossa plataforma.',
    privacyDataSecurity: 'Segurança dos Dados',
    privacyDataSecurityText: 'Implementamos medidas de segurança apropriadas para proteger as suas informações pessoais contra acesso não autorizado, alteração ou destruição.',
    privacyUserRights: 'Os Seus Direitos',
    privacyUserRightsText: 'Tem o direito de aceder, corrigir ou eliminar os seus dados pessoais. Pode gerir as suas informações através das definições da sua conta.',
    privacyCookies: 'Cookies',
    privacyCookiesText: 'Utilizamos cookies para melhorar a sua experiência. Pode controlar as definições de cookies através das preferências do seu navegador.',
    privacyChanges: 'Alterações a esta Política',
    privacyChangesText: 'Podemos atualizar esta Política de Privacidade periodicamente. Notificá-lo-emos sobre quaisquer alterações publicando a nova política nesta página.',
    privacyContact: 'Contacte-nos',
    privacyContactText: 'Se tiver dúvidas sobre esta Política de Privacidade, por favor contacte-nos.',
  },
  fr: {
    // Public Guest Page
    findYourSeat: 'Trouvez Votre Place',
    searchPlaceholder: 'Tapez votre nom...',
    yourTable: 'Votre Table',
    noResults: "Nous n'avons pas trouvé ce nom. Veuillez vérifier avec l'hôte ou essayer une autre orthographe.",
    startTyping: 'Commencez à taper votre nom pour trouver votre table',
    tableInfo: 'Info Table',
    personalNote: 'Note Personnelle',
    // Share a moment
    yourViewOfTheDay: 'Ton regard sur la journée',
    shareAMoment: 'Partage un moment',
    shareAnotherMoment: 'Partage un autre moment',
    saveLinkToReturnLater: 'Enregistre ce lien pour revenir plus tard',
    momentsShared: 'Tu as partagé tes moments',
    savedForThem: 'Conservés pour eux.',
    // Auth
    login: 'Connexion',
    register: "S'inscrire",
    email: 'E-mail',
    password: 'Mot de passe',
    name: 'Nom',
    confirmPassword: 'Confirmer le mot de passe',
    dontHaveAccount: "Vous n'avez pas de compte ?",
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    welcome: 'Bienvenue !',
    welcomeBack: 'Bon retour !',
    passwordsDoNotMatch: 'Les mots de passe ne correspondent pas. Veuillez vérifier et réessayer.',
    // Dashboard
    myEvents: 'Mes Événements',
    createEvent: 'Créer un Événement',
    noEvents: "Pas encore d'événements. Créez votre premier événement !",
    guests: 'invités',
    viewQR: 'Voir QR',
    manage: 'Gérer',
    // Event Setup
    eventDetails: "Détails de l'Événement",
    eventName: "Nom de l'Événement",
    eventDate: 'Date',
    eventLocation: 'Lieu',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    // Guests & Tables
    guestList: 'Liste des Invités',
    tables: 'Tables',
    addGuest: 'Ajouter un Invité',
    addTable: 'Ajouter une Table',
    uploadCSV: 'Importer CSV',
    downloadTemplate: 'Modèle CSV',
    deleteAllGuests: 'Tout Supprimer',
    confirmDeleteAllGuests: 'Êtes-vous sûr de vouloir supprimer TOUS les invités ? Cette action est irréversible.',
    allGuestsDeleted: '{count} invités supprimés avec succès',
    // Delete Event
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer',
    eventDeleted: 'Événement supprimé avec succès',
    deleteError: 'Échec de la suppression',
    fullName: 'Nom Complet',
    group: 'Groupe',
    notes: 'Notes',
    table: 'Table',
    capacity: 'Capacité',
    tableName: 'Nom de la Table',
    tableShape: 'Forme de la Table',
    searchGuests: 'Rechercher des invités...',
    filterByTable: 'Filtrer par table',
    allTables: 'Toutes les Tables',
    noTableAssigned: 'Aucune table assignée',
    // QR Code
    qrCode: 'Code QR',
    downloadQR: 'Télécharger le Code QR',
    generateQR: 'Générer le Code QR',
    qrGenerated: 'Code QR généré !',
    qrInstructions: 'Téléchargez ce code QR et placez-le sur la signalétique de votre événement ou importez-le dans Canva.',
    publicLink: 'Lien Public',
    qrColor: 'Couleur du Code QR',
    customColor: 'Personnalisé',
    noQRGenerated: 'Aucun code QR généré',
    applying: 'Application',
    qrColorPremiumFeature: 'La personnalisation de la couleur du code QR est une fonctionnalité premium',
    upgradeToPremium: 'Passer à Premium',
    // CSV
    csvFormat: 'Format CSV : full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Astuce : Le téléchargement met à jour les invités existants (par nom) et en ajoute de nouveaux.',
    importSuccess: 'Importation réussie !',
    // Language
    language: 'Langue',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    or: 'ou',
    signInWithGoogle: 'Se connecter avec Google',
    // Actions
    edit: 'Modifier',
    back: 'Retour',
    logout: 'Déconnexion',
    // Support Contact
    supportContact: 'Contact Support',
    supportSubject: 'Sujet',
    supportMessage: 'Message',
    supportSubjectPlaceholder: 'Comment pouvons-nous vous aider ?',
    supportMessagePlaceholder: 'Décrivez votre question ou problème en détail...',
    supportSendMessage: 'Envoyer le Message',
    supportSending: 'Envoi en cours...',
    supportHelpText: 'Vous avez une question ou besoin d\'aide ? Envoyez-nous un message et nous vous répondrons dès que possible.',
    supportSuccess: 'Demande de support envoyée avec succès !',
    supportError: 'Échec de l\'envoi de la demande de support',
    supportValidationError: 'Veuillez remplir le sujet et le message',
    // Upgrade & Pricing
    upgrade: 'Mettre à niveau',
    upgradeEvent: 'Mettre à Niveau l\'Événement',
    upgradeNow: 'Mettre à Niveau Maintenant',
    currentPlan: 'Plan Actuel',
    current: 'Actuel',
    tryDaysFree: 'Essayez {days} Jours Gratuitement',
    trialActive: 'Période d\'Essai Active',
    trialUsed: 'Essai utilisé',
    trial: 'Essai',
    viewFullPricing: 'Voir Tous les Prix et Fonctionnalités',
    unlockPremiumFeatures: 'Débloquez des fonctionnalités premium pour rendre votre événement inoubliable.',
    chooseYourPlan: 'Choisissez le plan qui correspond à vos besoins.',
    // Plan Limit Messages
    planLimitReached: 'Vous avez atteint la limite de votre plan. Mettez à niveau pour continuer.',
    planLimitGuests: 'Vous avez atteint la limite d\'invités. Mettez à niveau pour en ajouter.',
    planLimitEventsFree: 'Vous avez atteint la limite d\'événements. Passez à Pro pour 3 événements.',
    planLimitEventsPro: 'Vous avez atteint le maximum de 3 événements pour le plan Pro.',
    haveVoucher: 'Vous avez un code promo ?',
    enterVoucherCode: 'Entrez le code promo',
    apply: 'Appliquer',
    selectPlanFirst: 'Sélectionnez d\'abord un plan pour appliquer le code',
    voucherApplied: 'Code promo appliqué !',
    youSave: 'Vous économisez',
    featureComparison: 'Comparaison des Fonctionnalités',
    feature: 'Fonctionnalité',
    maximumGuests: 'Nombre Maximum d\'Invités',
    unlimited: 'Illimité',
    colorThemes: 'Thèmes de Couleurs',
    defaultOnly: 'Par défaut uniquement',
    customMessages: 'Messages Personnalisés',
    backgroundImages: 'Images de Fond',
    customQrColor: 'Couleur du Code QR Personnalisée',
    presetThemes: 'Thèmes Prédéfinis',
    allColorThemes: 'Tous les thèmes de couleurs',
    upToEvents: 'Jusqu\'à {count} événements',
    oneEvent: '1 événement',
    tax: 'Taxe',
    total: 'Total',
    processing: 'Traitement...',
    free: 'Gratuit',
    premium: 'Premium',
    premiumPlus: 'Premium Plus',
    pro: 'Pro',
    freeDescription: 'Fonctionnalités de base pour petits événements',
    premiumDescription: 'Toutes les fonctionnalités avec invités illimités',
    proDescription: 'Toutes les fonctionnalités avec invités illimités et plusieurs événements',
    // Upgrade Popup
    premiumFeature: 'Fonctionnalité Premium',
    premiumFeaturesRequired: 'Les fonctionnalités suivantes nécessitent un plan payant pour être enregistrées:',
    customEventMessage: 'Message d\'Événement Personnalisé',
    customColorTheme: 'Thème de Couleurs Personnalisé',
    customColorSettings: 'Paramètres de Couleurs Personnalisés',
    upgradeToUnlock: 'Passez à un plan supérieur pour débloquer ces fonctionnalités et faire ressortir votre événement!',
    // Forgot Password & Legal
    forgotPassword: 'Mot de passe oublié?',
    bySigningIn: 'En vous connectant, vous acceptez nos',
    terms: 'Conditions',
    and: 'et',
    privacyPolicy: 'Politique de Confidentialité',
    // Terms Page
    termsOfService: 'Conditions d\'Utilisation',
    termsLastUpdated: 'Dernière mise à jour',
    termsIntro: 'Bienvenue sur Digital Seating Chart. En accédant ou en utilisant notre service, vous acceptez d\'être lié par ces Conditions d\'Utilisation.',
    termsAcceptance: 'Acceptation des Conditions',
    termsAcceptanceText: 'En accédant et en utilisant Digital Seating Chart, vous acceptez et convenez d\'être lié par les termes et dispositions de cet accord.',
    termsUseOfService: 'Utilisation du Service',
    termsUseOfServiceText: 'Vous pouvez utiliser notre service uniquement à des fins légales. Vous acceptez de ne pas utiliser le service d\'une manière qui viole les lois ou réglementations applicables.',
    termsUserAccounts: 'Comptes Utilisateur',
    termsUserAccountsText: 'Lorsque vous créez un compte chez nous, vous devez fournir des informations exactes et complètes. Vous êtes responsable de la protection de vos identifiants de compte.',
    termsIntellectualProperty: 'Propriété Intellectuelle',
    termsIntellectualPropertyText: 'Le service et son contenu original, ses fonctionnalités sont la propriété de Digital Seating Chart et sont protégés par les lois internationales sur le droit d\'auteur et la propriété intellectuelle.',
    termsTermination: 'Résiliation',
    termsTerminationText: 'Nous pouvons résilier ou suspendre votre compte immédiatement, sans préavis ni responsabilité, pour quelque raison que ce soit, y compris en cas de violation de ces Conditions.',
    termsLimitation: 'Limitation de Responsabilité',
    termsLimitationText: 'En aucun cas Digital Seating Chart ne sera responsable de tout dommage indirect, accessoire, spécial, consécutif ou punitif résultant de votre utilisation du service.',
    termsChanges: 'Modifications des Conditions',
    termsChangesText: 'Nous nous réservons le droit de modifier ou de remplacer ces Conditions à tout moment. Nous vous informerons de tout changement en publiant les nouvelles Conditions sur cette page.',
    termsContact: 'Nous Contacter',
    termsContactText: 'Si vous avez des questions concernant ces Conditions, veuillez nous contacter.',
    // Privacy Page
    privacyPolicyTitle: 'Politique de Confidentialité',
    privacyLastUpdated: 'Dernière mise à jour',
    privacyIntro: 'Votre confidentialité est importante pour nous. Cette Politique de Confidentialité explique comment nous collectons, utilisons et protégeons vos informations.',
    privacyDataCollection: 'Informations que Nous Collectons',
    privacyDataCollectionText: 'Nous collectons les informations que vous fournissez directement, telles que votre nom, adresse e-mail et détails de l\'événement. Nous collectons également des données d\'utilisation pour améliorer notre service.',
    privacyDataUse: 'Comment Nous Utilisons Vos Informations',
    privacyDataUseText: 'Nous utilisons vos informations pour fournir et améliorer nos services, communiquer avec vous et assurer la sécurité de notre plateforme.',
    privacyDataSharing: 'Partage d\'Informations',
    privacyDataSharingText: 'Nous ne vendons pas vos informations personnelles. Nous pouvons partager des données avec des prestataires de services qui nous aident à exploiter notre plateforme.',
    privacyDataSecurity: 'Sécurité des Données',
    privacyDataSecurityText: 'Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations personnelles contre tout accès non autorisé, modification ou destruction.',
    privacyUserRights: 'Vos Droits',
    privacyUserRightsText: 'Vous avez le droit d\'accéder, de corriger ou de supprimer vos données personnelles. Vous pouvez gérer vos informations via les paramètres de votre compte.',
    privacyCookies: 'Cookies',
    privacyCookiesText: 'Nous utilisons des cookies pour améliorer votre expérience. Vous pouvez contrôler les paramètres des cookies via les préférences de votre navigateur.',
    privacyChanges: 'Modifications de cette Politique',
    privacyChangesText: 'Nous pouvons mettre à jour cette Politique de Confidentialité de temps en temps. Nous vous informerons de tout changement en publiant la nouvelle politique sur cette page.',
    privacyContact: 'Nous Contacter',
    privacyContactText: 'Si vous avez des questions concernant cette Politique de Confidentialité, veuillez nous contacter.',
  },
  es: {
    // Public Guest Page
    findYourSeat: 'Encuentra Tu Asiento',
    searchPlaceholder: 'Escribe tu nombre...',
    yourTable: 'Tu Mesa',
    noResults: 'No encontramos ese nombre. Por favor, verifica con el anfitrión o intenta con otra ortografía.',
    startTyping: 'Comienza a escribir tu nombre para encontrar tu mesa',
    tableInfo: 'Información de Mesa',
    personalNote: 'Nota Personal',
    // Share a moment
    yourViewOfTheDay: 'Tu mirada del día',
    shareAMoment: 'Comparte un momento',
    shareAnotherMoment: 'Comparte otro momento',
    saveLinkToReturnLater: 'Guarda este enlace para volver más tarde',
    momentsShared: 'Has compartido tus momentos',
    savedForThem: 'Guardados para ellos.',
    // Auth
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    name: 'Nombre',
    confirmPassword: 'Confirmar Contraseña',
    dontHaveAccount: '¿No tienes una cuenta?',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    welcome: '¡Bienvenido!',
    welcomeBack: '¡Bienvenido de nuevo!',
    passwordsDoNotMatch: 'Las contraseñas no coinciden. Por favor, verifica e intenta de nuevo.',
    // Dashboard
    myEvents: 'Mis Eventos',
    createEvent: 'Crear Evento',
    noEvents: 'Aún no hay eventos. ¡Crea tu primer evento!',
    guests: 'invitados',
    viewQR: 'Ver QR',
    manage: 'Gestionar',
    // Event Setup
    eventDetails: 'Detalles del Evento',
    eventName: 'Nombre del Evento',
    eventDate: 'Fecha',
    eventLocation: 'Ubicación',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    // Guests & Tables
    guestList: 'Lista de Invitados',
    tables: 'Mesas',
    addGuest: 'Agregar Invitado',
    addTable: 'Agregar Mesa',
    uploadCSV: 'Importar CSV',
    downloadTemplate: 'Plantilla CSV',
    deleteAllGuests: 'Eliminar Todos',
    confirmDeleteAllGuests: '¿Estás seguro de que deseas eliminar TODOS los invitados? Esta acción no se puede deshacer.',
    allGuestsDeleted: '{count} invitados eliminados con éxito',
    // Delete Event
    confirmDelete: '¿Estás seguro de que deseas eliminar',
    eventDeleted: 'Evento eliminado con éxito',
    deleteError: 'Error al eliminar',
    fullName: 'Nombre Completo',
    group: 'Grupo',
    notes: 'Notas',
    table: 'Mesa',
    capacity: 'Capacidad',
    tableName: 'Nombre de la Mesa',
    tableShape: 'Forma de la Mesa',
    searchGuests: 'Buscar invitados...',
    filterByTable: 'Filtrar por mesa',
    allTables: 'Todas las Mesas',
    noTableAssigned: 'Sin mesa asignada',
    // QR Code
    qrCode: 'Código QR',
    downloadQR: 'Descargar Código QR',
    generateQR: 'Generar Código QR',
    qrGenerated: '¡Código QR generado!',
    qrInstructions: 'Descarga este código QR y colócalo en la señalización de tu evento o impórtalo en Canva.',
    publicLink: 'Enlace Público',
    qrColor: 'Color del Código QR',
    customColor: 'Personalizado',
    noQRGenerated: 'Ningún código QR generado aún',
    applying: 'Aplicando',
    qrColorPremiumFeature: 'La personalización del color del código QR es una función premium',
    upgradeToPremium: 'Actualizar a Premium',
    // CSV
    csvFormat: 'Formato CSV: full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Consejo: Subir actualiza invitados existentes (por nombre) y añade nuevos.',
    importSuccess: '¡Importación exitosa!',
    // Language
    language: 'Idioma',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    or: 'o',
    signInWithGoogle: 'Iniciar sesión con Google',
    // Actions
    edit: 'Editar',
    back: 'Volver',
    logout: 'Cerrar Sesión',
    // Support Contact
    supportContact: 'Contacto de Soporte',
    supportSubject: 'Asunto',
    supportMessage: 'Mensaje',
    supportSubjectPlaceholder: '¿En qué podemos ayudarte?',
    supportMessagePlaceholder: 'Describe tu pregunta o problema en detalle...',
    supportSendMessage: 'Enviar Mensaje',
    supportSending: 'Enviando...',
    supportHelpText: '¿Tienes una pregunta o necesitas ayuda? Envíanos un mensaje y te responderemos lo antes posible.',
    supportSuccess: '¡Solicitud de soporte enviada con éxito!',
    supportError: 'Error al enviar la solicitud de soporte',
    supportValidationError: 'Por favor, completa el asunto y el mensaje',
    // Upgrade & Pricing
    upgrade: 'Mejorar',
    upgradeEvent: 'Mejorar Evento',
    upgradeNow: 'Mejorar Ahora',
    currentPlan: 'Plan Actual',
    current: 'Actual',
    tryDaysFree: 'Prueba {days} Días Gratis',
    trialActive: 'Período de Prueba Activo',
    trialUsed: 'Prueba usada',
    trial: 'Prueba',
    viewFullPricing: 'Ver Todos los Precios y Funciones',
    unlockPremiumFeatures: 'Desbloquea funciones premium para hacer tu evento inolvidable.',
    chooseYourPlan: 'Elige el plan que se adapte a tus necesidades.',
    // Plan Limit Messages
    planLimitReached: 'Has alcanzado el límite de tu plan. Mejora para continuar.',
    planLimitGuests: 'Has alcanzado el límite de invitados. Mejora para añadir más.',
    planLimitEventsFree: 'Has alcanzado el límite de eventos. Mejora a Pro para hasta 3 eventos.',
    planLimitEventsPro: 'Has alcanzado el máximo de 3 eventos para el plan Pro.',
    haveVoucher: '¿Tienes un código de descuento?',
    enterVoucherCode: 'Introduce el código de descuento',
    apply: 'Aplicar',
    selectPlanFirst: 'Selecciona un plan primero para aplicar el código',
    voucherApplied: '¡Código aplicado!',
    youSave: 'Ahorras',
    featureComparison: 'Comparación de Funciones',
    feature: 'Función',
    maximumGuests: 'Máximo de Invitados',
    unlimited: 'Ilimitado',
    colorThemes: 'Temas de Colores',
    defaultOnly: 'Solo predeterminado',
    customMessages: 'Mensajes Personalizados',
    backgroundImages: 'Imágenes de Fondo',
    customQrColor: 'Color del Código QR Personalizado',
    presetThemes: 'Temas Predefinidos',
    allColorThemes: 'Todos los temas de colores',
    upToEvents: 'Hasta {count} eventos',
    oneEvent: '1 evento',
    tax: 'Impuesto',
    total: 'Total',
    processing: 'Procesando...',
    free: 'Gratis',
    premium: 'Premium',
    premiumPlus: 'Premium Plus',
    pro: 'Pro',
    freeDescription: 'Funciones básicas para pequeños eventos',
    premiumDescription: 'Todas las funciones con invitados ilimitados',
    proDescription: 'Todas las funciones con invitados ilimitados y múltiples eventos',
    // Upgrade Popup
    premiumFeature: 'Función Premium',
    premiumFeaturesRequired: 'Las siguientes funciones requieren un plan de pago para guardar:',
    customEventMessage: 'Mensaje de Evento Personalizado',
    customColorTheme: 'Tema de Colores Personalizado',
    customColorSettings: 'Configuración de Colores Personalizada',
    upgradeToUnlock: '¡Actualiza para desbloquear estas funciones y hacer que tu evento destaque!',
    // Forgot Password & Legal
    forgotPassword: '¿Olvidaste tu contraseña?',
    bySigningIn: 'Al iniciar sesión, aceptas nuestros',
    terms: 'Términos',
    and: 'y',
    privacyPolicy: 'Política de Privacidad',
    // Terms Page
    termsOfService: 'Términos de Servicio',
    termsLastUpdated: 'Última actualización',
    termsIntro: 'Bienvenido a Digital Seating Chart. Al acceder o utilizar nuestro servicio, aceptas estar sujeto a estos Términos de Servicio.',
    termsAcceptance: 'Aceptación de los Términos',
    termsAcceptanceText: 'Al acceder y utilizar Digital Seating Chart, aceptas y acuerdas estar sujeto a los términos y disposiciones de este acuerdo.',
    termsUseOfService: 'Uso del Servicio',
    termsUseOfServiceText: 'Puedes utilizar nuestro servicio solo para fines legales. Aceptas no utilizar el servicio de manera que viole cualquier ley o regulación aplicable.',
    termsUserAccounts: 'Cuentas de Usuario',
    termsUserAccountsText: 'Cuando creas una cuenta con nosotros, debes proporcionar información precisa y completa. Eres responsable de proteger las credenciales de tu cuenta.',
    termsIntellectualProperty: 'Propiedad Intelectual',
    termsIntellectualPropertyText: 'El servicio y su contenido original, características y funcionalidad son propiedad de Digital Seating Chart y están protegidos por leyes internacionales de derechos de autor y propiedad intelectual.',
    termsTermination: 'Terminación',
    termsTerminationText: 'Podemos terminar o suspender tu cuenta inmediatamente, sin previo aviso ni responsabilidad, por cualquier motivo, incluyendo incumplimiento de estos Términos.',
    termsLimitation: 'Limitación de Responsabilidad',
    termsLimitationText: 'En ningún caso Digital Seating Chart será responsable de daños indirectos, incidentales, especiales, consecuentes o punitivos resultantes de tu uso del servicio.',
    termsChanges: 'Cambios en los Términos',
    termsChangesText: 'Nos reservamos el derecho de modificar o reemplazar estos Términos en cualquier momento. Te notificaremos de cualquier cambio publicando los nuevos Términos en esta página.',
    termsContact: 'Contáctanos',
    termsContactText: 'Si tienes alguna pregunta sobre estos Términos, por favor contáctanos.',
    // Privacy Page
    privacyPolicyTitle: 'Política de Privacidad',
    privacyLastUpdated: 'Última actualización',
    privacyIntro: 'Tu privacidad es importante para nosotros. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información.',
    privacyDataCollection: 'Información que Recopilamos',
    privacyDataCollectionText: 'Recopilamos información que proporcionas directamente, como tu nombre, dirección de correo electrónico y detalles del evento. También recopilamos datos de uso para mejorar nuestro servicio.',
    privacyDataUse: 'Cómo Usamos Tu Información',
    privacyDataUseText: 'Usamos tu información para proporcionar y mejorar nuestros servicios, comunicarnos contigo y garantizar la seguridad de nuestra plataforma.',
    privacyDataSharing: 'Compartir Información',
    privacyDataSharingText: 'No vendemos tu información personal. Podemos compartir datos con proveedores de servicios que nos ayudan a operar nuestra plataforma.',
    privacyDataSecurity: 'Seguridad de Datos',
    privacyDataSecurityText: 'Implementamos medidas de seguridad apropiadas para proteger tu información personal contra acceso no autorizado, alteración o destrucción.',
    privacyUserRights: 'Tus Derechos',
    privacyUserRightsText: 'Tienes derecho a acceder, corregir o eliminar tus datos personales. Puedes gestionar tu información a través de la configuración de tu cuenta.',
    privacyCookies: 'Cookies',
    privacyCookiesText: 'Usamos cookies para mejorar tu experiencia. Puedes controlar la configuración de cookies a través de las preferencias de tu navegador.',
    privacyChanges: 'Cambios en esta Política',
    privacyChangesText: 'Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos de cualquier cambio publicando la nueva política en esta página.',
    privacyContact: 'Contáctanos',
    privacyContactText: 'Si tienes preguntas sobre esta Política de Privacidad, por favor contáctanos.',
  },
  ru: {
    // Public Guest Page
    findYourSeat: 'Найдите своё место',
    searchPlaceholder: 'Введите ваше имя...',
    yourTable: 'Ваш стол',
    noResults: 'Мы не нашли это имя. Пожалуйста, уточните у организатора или попробуйте другое написание.',
    startTyping: 'Начните вводить имя, чтобы найти свой стол',
    tableInfo: 'Информация о столе',
    personalNote: 'Личная заметка',
    // Share a moment
    yourViewOfTheDay: 'Твой взгляд на день',
    shareAMoment: 'Поделись моментом',
    shareAnotherMoment: 'Поделись ещё одним моментом',
    saveLinkToReturnLater: 'Сохрани эту ссылку, чтобы вернуться позже',
    momentsShared: 'Ты поделился своими моментами',
    savedForThem: 'Сохранено для них.',
    // Auth
    login: 'Войти',
    register: 'Регистрация',
    email: 'Эл. почта',
    password: 'Пароль',
    name: 'Имя',
    confirmPassword: 'Подтвердите пароль',
    dontHaveAccount: 'Нет аккаунта?',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    welcome: 'Добро пожаловать!',
    welcomeBack: 'С возвращением!',
    passwordsDoNotMatch: 'Пароли не совпадают. Пожалуйста, проверьте и попробуйте снова.',
    // Dashboard
    myEvents: 'Мои мероприятия',
    createEvent: 'Создать мероприятие',
    noEvents: 'Пока нет мероприятий. Создайте своё первое!',
    guests: 'гостей',
    viewQR: 'QR код',
    manage: 'Управление',
    // Event Setup
    eventDetails: 'Детали мероприятия',
    eventName: 'Название',
    eventDate: 'Дата',
    eventLocation: 'Место',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    // Guests & Tables
    guestList: 'Список гостей',
    tables: 'Столы',
    addGuest: 'Добавить гостя',
    addTable: 'Добавить стол',
    uploadCSV: 'Загрузить CSV',
    downloadTemplate: 'Шаблон CSV',
    deleteAllGuests: 'Удалить всех',
    confirmDeleteAllGuests: 'Вы уверены, что хотите удалить ВСЕХ гостей? Это действие нельзя отменить.',
    allGuestsDeleted: '{count} гостей успешно удалено',
    // Delete Event
    confirmDelete: 'Вы уверены, что хотите удалить',
    eventDeleted: 'Событие успешно удалено',
    deleteError: 'Ошибка при удалении',
    fullName: 'Полное имя',
    group: 'Группа',
    notes: 'Заметки',
    table: 'Стол',
    capacity: 'Вместимость',
    tableName: 'Название стола',
    tableShape: 'Форма стола',
    searchGuests: 'Поиск гостей...',
    filterByTable: 'Фильтр по столу',
    allTables: 'Все столы',
    noTableAssigned: 'Стол не назначен',
    // QR Code
    qrCode: 'QR код',
    downloadQR: 'Скачать QR код',
    generateQR: 'Создать QR код',
    qrGenerated: 'QR код создан!',
    qrInstructions: 'Скачайте этот QR код и разместите на вывеске мероприятия или импортируйте в Canva.',
    publicLink: 'Публичная ссылка',
    qrColor: 'Цвет QR кода',
    customColor: 'Свой цвет',
    noQRGenerated: 'QR код ещё не создан',
    applying: 'Применяется',
    qrColorPremiumFeature: 'Настройка цвета QR-кода — премиум-функция',
    upgradeToPremium: 'Перейти на Premium',
    // CSV
    csvFormat: 'Формат CSV: full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Совет: Загрузка обновляет существующих гостей (по имени) и добавляет новых.',
    importSuccess: 'Импорт успешен!',
    // Language
    language: 'Язык',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    or: 'или',
    signInWithGoogle: 'Войти через Google',
    // Actions
    edit: 'Редактировать',
    back: 'Назад',
    logout: 'Выйти',
    // Support Contact
    supportContact: 'Служба поддержки',
    supportSubject: 'Тема',
    supportMessage: 'Сообщение',
    supportSubjectPlaceholder: 'Чем мы можем вам помочь?',
    supportMessagePlaceholder: 'Опишите ваш вопрос или проблему подробно...',
    supportSendMessage: 'Отправить сообщение',
    supportSending: 'Отправка...',
    supportHelpText: 'Есть вопрос или нужна помощь? Отправьте нам сообщение, и мы ответим как можно скорее.',
    supportSuccess: 'Запрос в поддержку успешно отправлен!',
    supportError: 'Не удалось отправить запрос в поддержку',
    supportValidationError: 'Пожалуйста, заполните тему и сообщение',
    // Upgrade & Pricing
    upgrade: 'Улучшить',
    upgradeEvent: 'Улучшить Событие',
    upgradeNow: 'Улучшить Сейчас',
    currentPlan: 'Текущий План',
    current: 'Текущий',
    tryDaysFree: 'Попробуйте {days} Дней Бесплатно',
    trialActive: 'Пробный Период Активен',
    trialUsed: 'Пробный период использован',
    trial: 'Пробный',
    viewFullPricing: 'Смотреть Все Цены и Функции',
    unlockPremiumFeatures: 'Разблокируйте премиум-функции, чтобы сделать ваше мероприятие незабываемым.',
    chooseYourPlan: 'Выберите план, который соответствует вашим потребностям.',
    // Plan Limit Messages
    planLimitReached: 'Вы достигли лимита вашего плана. Улучшите, чтобы продолжить.',
    planLimitGuests: 'Вы достигли лимита гостей. Улучшите, чтобы добавить больше.',
    planLimitEventsFree: 'Вы достигли лимита событий. Улучшите до Pro для 3 событий.',
    planLimitEventsPro: 'Вы достигли максимума в 3 события для плана Pro.',
    haveVoucher: 'Есть промокод?',
    enterVoucherCode: 'Введите промокод',
    apply: 'Применить',
    selectPlanFirst: 'Сначала выберите план для применения промокода',
    voucherApplied: 'Промокод применён!',
    youSave: 'Вы экономите',
    featureComparison: 'Сравнение Функций',
    feature: 'Функция',
    maximumGuests: 'Максимум Гостей',
    unlimited: 'Безлимитно',
    colorThemes: 'Цветовые Темы',
    defaultOnly: 'Только стандартная',
    customMessages: 'Персональные Сообщения',
    backgroundImages: 'Фоновые Изображения',
    customQrColor: 'Пользовательский Цвет QR-кода',
    presetThemes: 'Готовые Темы',
    allColorThemes: 'Все цветовые темы',
    upToEvents: 'До {count} событий',
    oneEvent: '1 событие',
    tax: 'Налог',
    total: 'Итого',
    processing: 'Обработка...',
    free: 'Бесплатно',
    premium: 'Премиум',
    premiumPlus: 'Премиум Плюс',
    pro: 'Про',
    freeDescription: 'Базовые функции для небольших мероприятий',
    premiumDescription: 'Все функции с неограниченным количеством гостей',
    proDescription: 'Все функции с неограниченным количеством гостей и несколькими событиями',
    // Upgrade Popup
    premiumFeature: 'Премиум Функция',
    premiumFeaturesRequired: 'Следующие функции требуют платного плана для сохранения:',
    customEventMessage: 'Персональное Сообщение События',
    customColorTheme: 'Персональная Цветовая Тема',
    customColorSettings: 'Персональные Настройки Цветов',
    upgradeToUnlock: 'Обновитесь, чтобы разблокировать эти функции и выделить своё событие!',
    // Forgot Password & Legal
    forgotPassword: 'Забыли пароль?',
    bySigningIn: 'Входя в систему, вы соглашаетесь с нашими',
    terms: 'Условиями',
    and: 'и',
    privacyPolicy: 'Политикой конфиденциальности',
    // Terms Page
    termsOfService: 'Условия использования',
    termsLastUpdated: 'Последнее обновление',
    termsIntro: 'Добро пожаловать в Digital Seating Chart. Получая доступ к нашему сервису или используя его, вы соглашаетесь соблюдать настоящие Условия использования.',
    termsAcceptance: 'Принятие условий',
    termsAcceptanceText: 'Получая доступ к Digital Seating Chart и используя его, вы принимаете и соглашаетесь соблюдать условия и положения настоящего соглашения.',
    termsUseOfService: 'Использование сервиса',
    termsUseOfServiceText: 'Вы можете использовать наш сервис только в законных целях. Вы соглашаетесь не использовать сервис способом, нарушающим применимые законы или правила.',
    termsUserAccounts: 'Учётные записи пользователей',
    termsUserAccountsText: 'При создании учётной записи у нас вы должны предоставить точную и полную информацию. Вы несёте ответственность за защиту учётных данных.',
    termsIntellectualProperty: 'Интеллектуальная собственность',
    termsIntellectualPropertyText: 'Сервис и его оригинальный контент, функции и функциональность принадлежат Digital Seating Chart и защищены международными законами об авторском праве и интеллектуальной собственности.',
    termsTermination: 'Прекращение',
    termsTerminationText: 'Мы можем немедленно прекратить или приостановить действие вашей учётной записи без предварительного уведомления или ответственности по любой причине, включая нарушение настоящих Условий.',
    termsLimitation: 'Ограничение ответственности',
    termsLimitationText: 'Ни при каких обстоятельствах Digital Seating Chart не несёт ответственности за косвенные, случайные, особые, последующие или штрафные убытки, возникшие в результате использования вами сервиса.',
    termsChanges: 'Изменения условий',
    termsChangesText: 'Мы оставляем за собой право изменять или заменять настоящие Условия в любое время. Мы уведомим вас о любых изменениях, опубликовав новые Условия на этой странице.',
    termsContact: 'Связаться с нами',
    termsContactText: 'Если у вас есть вопросы по этим Условиям, свяжитесь с нами.',
    // Privacy Page
    privacyPolicyTitle: 'Политика конфиденциальности',
    privacyLastUpdated: 'Последнее обновление',
    privacyIntro: 'Ваша конфиденциальность важна для нас. Настоящая Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу информацию.',
    privacyDataCollection: 'Информация, которую мы собираем',
    privacyDataCollectionText: 'Мы собираем информацию, которую вы предоставляете напрямую, такую как ваше имя, адрес электронной почты и данные о мероприятии. Мы также собираем данные об использовании для улучшения нашего сервиса.',
    privacyDataUse: 'Как мы используем вашу информацию',
    privacyDataUseText: 'Мы используем вашу информацию для предоставления и улучшения наших услуг, общения с вами и обеспечения безопасности нашей платформы.',
    privacyDataSharing: 'Обмен информацией',
    privacyDataSharingText: 'Мы не продаём вашу личную информацию. Мы можем делиться данными с поставщиками услуг, которые помогают нам в работе нашей платформы.',
    privacyDataSecurity: 'Безопасность данных',
    privacyDataSecurityText: 'Мы применяем соответствующие меры безопасности для защиты вашей личной информации от несанкционированного доступа, изменения или уничтожения.',
    privacyUserRights: 'Ваши права',
    privacyUserRightsText: 'Вы имеете право на доступ, исправление или удаление ваших личных данных. Вы можете управлять своей информацией через настройки учётной записи.',
    privacyCookies: 'Файлы cookie',
    privacyCookiesText: 'Мы используем файлы cookie для улучшения вашего опыта. Вы можете управлять настройками cookie через настройки вашего браузера.',
    privacyChanges: 'Изменения в этой политике',
    privacyChangesText: 'Мы можем время от времени обновлять эту Политику конфиденциальности. Мы уведомим вас о любых изменениях, опубликовав новую политику на этой странице.',
    privacyContact: 'Связаться с нами',
    privacyContactText: 'Если у вас есть вопросы по этой Политике конфиденциальности, свяжитесь с нами.',
  },
  it: {
    // Public Guest Page
    findYourSeat: 'Trova il Tuo Posto',
    searchPlaceholder: 'Digita il tuo nome...',
    yourTable: 'Il Tuo Tavolo',
    noResults: 'Non abbiamo trovato questo nome. Per favore, verifica con l\'organizzatore o prova un\'altra ortografia.',
    startTyping: 'Inizia a digitare il tuo nome per trovare il tuo tavolo',
    tableInfo: 'Info Tavolo',
    personalNote: 'Nota Personale',
    // Share a moment
    yourViewOfTheDay: 'Il tuo sguardo sul giorno',
    shareAMoment: 'Condividi un momento',
    shareAnotherMoment: 'Condividi un altro momento',
    saveLinkToReturnLater: 'Salva questo link per tornare più tardi',
    momentsShared: 'Hai condiviso i tuoi momenti',
    savedForThem: 'Conservati per loro.',
    // Auth
    login: 'Accedi',
    register: 'Registrati',
    email: 'Email',
    password: 'Password',
    name: 'Nome',
    confirmPassword: 'Conferma Password',
    dontHaveAccount: 'Non hai un account?',
    alreadyHaveAccount: 'Hai già un account?',
    welcome: 'Benvenuto!',
    welcomeBack: 'Bentornato!',
    passwordsDoNotMatch: 'Le password non corrispondono. Per favore, controlla e riprova.',
    // Dashboard
    myEvents: 'I Miei Eventi',
    createEvent: 'Crea Evento',
    noEvents: 'Nessun evento ancora. Crea il tuo primo evento!',
    guests: 'ospiti',
    viewQR: 'Vedi QR',
    manage: 'Gestisci',
    // Event Setup
    eventDetails: 'Dettagli Evento',
    eventName: 'Nome Evento',
    eventDate: 'Data',
    eventLocation: 'Luogo',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    // Guests & Tables
    guestList: 'Lista Ospiti',
    tables: 'Tavoli',
    addGuest: 'Aggiungi Ospite',
    addTable: 'Aggiungi Tavolo',
    uploadCSV: 'Carica CSV',
    downloadTemplate: 'Modello CSV',
    deleteAllGuests: 'Elimina Tutti',
    confirmDeleteAllGuests: 'Sei sicuro di voler eliminare TUTTI gli ospiti? Questa azione non può essere annullata.',
    allGuestsDeleted: '{count} ospiti eliminati con successo',
    // Delete Event
    confirmDelete: 'Sei sicuro di voler eliminare',
    eventDeleted: 'Evento eliminato con successo',
    deleteError: 'Errore durante l\'eliminazione',
    fullName: 'Nome Completo',
    group: 'Gruppo',
    notes: 'Note',
    table: 'Tavolo',
    capacity: 'Capacità',
    tableName: 'Nome Tavolo',
    tableShape: 'Forma Tavolo',
    searchGuests: 'Cerca ospiti...',
    filterByTable: 'Filtra per tavolo',
    allTables: 'Tutti i Tavoli',
    noTableAssigned: 'Nessun tavolo assegnato',
    // QR Code
    qrCode: 'Codice QR',
    downloadQR: 'Scarica Codice QR',
    generateQR: 'Genera Codice QR',
    qrGenerated: 'Codice QR generato!',
    qrInstructions: 'Scarica questo codice QR e posizionalo sulla segnaletica del tuo evento o importalo in Canva.',
    publicLink: 'Link Pubblico',
    qrColor: 'Colore del Codice QR',
    customColor: 'Personalizzato',
    noQRGenerated: 'Nessun codice QR generato ancora',
    applying: 'Applicazione',
    qrColorPremiumFeature: 'La personalizzazione del colore del codice QR è una funzione premium',
    upgradeToPremium: 'Passa a Premium',
    // CSV
    csvFormat: 'Formato CSV: full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Suggerimento: Il caricamento aggiorna gli ospiti esistenti (per nome) e aggiunge i nuovi.',
    importSuccess: 'Importazione riuscita!',
    // Language
    language: 'Lingua',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    or: 'o',
    signInWithGoogle: 'Accedi con Google',
    // Actions
    edit: 'Modifica',
    back: 'Indietro',
    logout: 'Esci',
    // Support Contact
    supportContact: 'Contatto Supporto',
    supportSubject: 'Oggetto',
    supportMessage: 'Messaggio',
    supportSubjectPlaceholder: 'Come possiamo aiutarti?',
    supportMessagePlaceholder: 'Descrivi la tua domanda o problema in dettaglio...',
    supportSendMessage: 'Invia Messaggio',
    supportSending: 'Invio in corso...',
    supportHelpText: 'Hai una domanda o hai bisogno di aiuto? Inviaci un messaggio e ti risponderemo il prima possibile.',
    supportSuccess: 'Richiesta di supporto inviata con successo!',
    supportError: 'Impossibile inviare la richiesta di supporto',
    supportValidationError: 'Per favore, compila l\'oggetto e il messaggio',
    // Upgrade & Pricing
    upgrade: 'Aggiorna',
    upgradeEvent: 'Aggiorna Evento',
    upgradeNow: 'Aggiorna Ora',
    currentPlan: 'Piano Attuale',
    current: 'Attuale',
    tryDaysFree: 'Prova {days} Giorni Gratis',
    trialActive: 'Periodo di Prova Attivo',
    trialUsed: 'Prova usata',
    trial: 'Prova',
    viewFullPricing: 'Vedi Tutti i Prezzi e le Funzionalità',
    unlockPremiumFeatures: 'Sblocca le funzionalità premium per rendere il tuo evento indimenticabile.',
    chooseYourPlan: 'Scegli il piano che si adatta alle tue esigenze.',
    // Plan Limit Messages
    planLimitReached: 'Hai raggiunto il limite del tuo piano. Aggiorna per continuare.',
    planLimitGuests: 'Hai raggiunto il limite degli ospiti. Aggiorna per aggiungerne altri.',
    planLimitEventsFree: 'Hai raggiunto il limite degli eventi. Passa a Pro per 3 eventi.',
    planLimitEventsPro: 'Hai raggiunto il massimo di 3 eventi per il piano Pro.',
    haveVoucher: 'Hai un codice sconto?',
    enterVoucherCode: 'Inserisci il codice sconto',
    apply: 'Applica',
    selectPlanFirst: 'Seleziona prima un piano per applicare il codice',
    voucherApplied: 'Codice applicato!',
    youSave: 'Risparmi',
    featureComparison: 'Confronto Funzionalità',
    feature: 'Funzionalità',
    maximumGuests: 'Massimo Ospiti',
    unlimited: 'Illimitato',
    colorThemes: 'Temi Colore',
    defaultOnly: 'Solo predefinito',
    customMessages: 'Messaggi Personalizzati',
    backgroundImages: 'Immagini di Sfondo',
    customQrColor: 'Colore del Codice QR Personalizzato',
    presetThemes: 'Temi Predefiniti',
    allColorThemes: 'Tutti i temi colore',
    upToEvents: 'Fino a {count} eventi',
    oneEvent: '1 evento',
    tax: 'Tassa',
    total: 'Totale',
    processing: 'Elaborazione...',
    free: 'Gratuito',
    premium: 'Premium',
    premiumPlus: 'Premium Plus',
    pro: 'Pro',
    freeDescription: 'Funzionalità di base per piccoli eventi',
    premiumDescription: 'Tutte le funzionalità con ospiti illimitati',
    proDescription: 'Tutte le funzionalità con ospiti illimitati e più eventi',
    // Upgrade Popup
    premiumFeature: 'Funzionalità Premium',
    premiumFeaturesRequired: 'Le seguenti funzionalità richiedono un piano a pagamento per essere salvate:',
    customEventMessage: 'Messaggio Evento Personalizzato',
    customColorTheme: 'Tema Colori Personalizzato',
    customColorSettings: 'Impostazioni Colori Personalizzate',
    upgradeToUnlock: 'Aggiorna per sbloccare queste funzionalità e far risaltare il tuo evento!',
    // Forgot Password & Legal
    forgotPassword: 'Hai dimenticato la password?',
    bySigningIn: 'Accedendo, accetti i nostri',
    terms: 'Termini',
    and: 'e',
    privacyPolicy: 'Informativa sulla Privacy',
    // Terms Page
    termsOfService: 'Termini di Servizio',
    termsLastUpdated: 'Ultimo aggiornamento',
    termsIntro: 'Benvenuto su Digital Seating Chart. Accedendo o utilizzando il nostro servizio, accetti di essere vincolato da questi Termini di Servizio.',
    termsAcceptance: 'Accettazione dei Termini',
    termsAcceptanceText: 'Accedendo e utilizzando Digital Seating Chart, accetti e converti di essere vincolato ai termini e alle disposizioni di questo accordo.',
    termsUseOfService: 'Uso del Servizio',
    termsUseOfServiceText: 'Puoi utilizzare il nostro servizio solo per scopi legali. Accetti di non utilizzare il servizio in modo che violi le leggi o i regolamenti applicabili.',
    termsUserAccounts: 'Account Utente',
    termsUserAccountsText: 'Quando crei un account con noi, devi fornire informazioni accurate e complete. Sei responsabile della protezione delle credenziali del tuo account.',
    termsIntellectualProperty: 'Proprietà Intellettuale',
    termsIntellectualPropertyText: 'Il servizio e il suo contenuto originale, le caratteristiche e le funzionalità sono di proprietà di Digital Seating Chart e sono protetti dalle leggi internazionali sul diritto d\'autore e sulla proprietà intellettuale.',
    termsTermination: 'Risoluzione',
    termsTerminationText: 'Possiamo terminare o sospendere immediatamente il tuo account, senza preavviso o responsabilità, per qualsiasi motivo, inclusa la violazione di questi Termini.',
    termsLimitation: 'Limitazione di Responsabilità',
    termsLimitationText: 'In nessun caso Digital Seating Chart sarà responsabile per danni indiretti, incidentali, speciali, consequenziali o punitivi derivanti dal tuo uso del servizio.',
    termsChanges: 'Modifiche ai Termini',
    termsChangesText: 'Ci riserviamo il diritto di modificare o sostituire questi Termini in qualsiasi momento. Ti informeremo di eventuali modifiche pubblicando i nuovi Termini su questa pagina.',
    termsContact: 'Contattaci',
    termsContactText: 'Se hai domande su questi Termini, contattaci.',
    // Privacy Page
    privacyPolicyTitle: 'Informativa sulla Privacy',
    privacyLastUpdated: 'Ultimo aggiornamento',
    privacyIntro: 'La tua privacy è importante per noi. Questa Informativa sulla Privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni.',
    privacyDataCollection: 'Informazioni che Raccogliamo',
    privacyDataCollectionText: 'Raccogliamo le informazioni che fornisci direttamente, come il tuo nome, indirizzo email e dettagli dell\'evento. Raccogliamo anche dati di utilizzo per migliorare il nostro servizio.',
    privacyDataUse: 'Come Utilizziamo le Tue Informazioni',
    privacyDataUseText: 'Utilizziamo le tue informazioni per fornire e migliorare i nostri servizi, comunicare con te e garantire la sicurezza della nostra piattaforma.',
    privacyDataSharing: 'Condivisione delle Informazioni',
    privacyDataSharingText: 'Non vendiamo le tue informazioni personali. Potremmo condividere i dati con fornitori di servizi che ci aiutano a gestire la nostra piattaforma.',
    privacyDataSecurity: 'Sicurezza dei Dati',
    privacyDataSecurityText: 'Implementiamo misure di sicurezza appropriate per proteggere le tue informazioni personali da accessi non autorizzati, alterazioni o distruzione.',
    privacyUserRights: 'I Tuoi Diritti',
    privacyUserRightsText: 'Hai il diritto di accedere, correggere o eliminare i tuoi dati personali. Puoi gestire le tue informazioni tramite le impostazioni del tuo account.',
    privacyCookies: 'Cookie',
    privacyCookiesText: 'Utilizziamo i cookie per migliorare la tua esperienza. Puoi controllare le impostazioni dei cookie tramite le preferenze del tuo browser.',
    privacyChanges: 'Modifiche a questa Informativa',
    privacyChangesText: 'Potremmo aggiornare questa Informativa sulla Privacy di tanto in tanto. Ti informeremo di eventuali modifiche pubblicando la nuova informativa su questa pagina.',
    privacyContact: 'Contattaci',
    privacyContactText: 'Se hai domande su questa Informativa sulla Privacy, contattaci.',
  },
  el: {
    // Public Guest Page
    findYourSeat: 'Βρείτε τη Θέση σας',
    searchPlaceholder: 'Πληκτρολογήστε το όνομά σας...',
    yourTable: 'Το Τραπέζι σας',
    noResults: 'Δεν βρήκαμε αυτό το όνομα. Παρακαλούμε ελέγξτε με τον οικοδεσπότη ή δοκιμάστε διαφορετική ορθογραφία.',
    startTyping: 'Αρχίστε να πληκτρολογείτε το όνομά σας για να βρείτε το τραπέζι σας',
    tableInfo: 'Πληροφορίες Τραπεζιού',
    personalNote: 'Προσωπική Σημείωση',
    // Share a moment
    yourViewOfTheDay: 'Η ματιά σου στη μέρα',
    shareAMoment: 'Μοιράσου μια στιγμή',
    shareAnotherMoment: 'Μοιράσου άλλη μια στιγμή',
    saveLinkToReturnLater: 'Αποθήκευσε αυτόν τον σύνδεσμο για αργότερα',
    momentsShared: 'Μοιράστηκες τις στιγμές σου',
    savedForThem: 'Φυλάχτηκαν για αυτούς.',
    // Auth
    login: 'Σύνδεση',
    register: 'Εγγραφή',
    email: 'Email',
    password: 'Κωδικός',
    name: 'Όνομα',
    confirmPassword: 'Επιβεβαίωση Κωδικού',
    dontHaveAccount: 'Δεν έχετε λογαριασμό;',
    alreadyHaveAccount: 'Έχετε ήδη λογαριασμό;',
    welcome: 'Καλώς ήρθατε!',
    welcomeBack: 'Καλώς ήρθατε ξανά!',
    passwordsDoNotMatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν. Παρακαλώ ελέγξτε και δοκιμάστε ξανά.',
    // Dashboard
    myEvents: 'Οι Εκδηλώσεις μου',
    createEvent: 'Δημιουργία Εκδήλωσης',
    noEvents: 'Δεν υπάρχουν εκδηλώσεις ακόμα. Δημιουργήστε την πρώτη σας εκδήλωση!',
    guests: 'καλεσμένοι',
    viewQR: 'Προβολή QR',
    manage: 'Διαχείριση',
    // Event Setup
    eventDetails: 'Λεπτομέρειες Εκδήλωσης',
    eventName: 'Όνομα Εκδήλωσης',
    eventDate: 'Ημερομηνία',
    eventLocation: 'Τοποθεσία',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    delete: 'Διαγραφή',
    // Guests & Tables
    guestList: 'Λίστα Καλεσμένων',
    tables: 'Τραπέζια',
    addGuest: 'Προσθήκη Καλεσμένου',
    addTable: 'Προσθήκη Τραπεζιού',
    uploadCSV: 'Μεταφόρτωση CSV',
    downloadTemplate: 'Πρότυπο CSV',
    deleteAllGuests: 'Διαγραφή Όλων',
    confirmDeleteAllGuests: 'Είστε σίγουροι ότι θέλετε να διαγράψετε ΟΛΟΥΣ τους καλεσμένους; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    allGuestsDeleted: '{count} καλεσμένοι διαγράφηκαν επιτυχώς',
    // Delete Event
    confirmDelete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε',
    eventDeleted: 'Η εκδήλωση διαγράφηκε επιτυχώς',
    deleteError: 'Αποτυχία διαγραφής',
    fullName: 'Πλήρες Όνομα',
    group: 'Ομάδα',
    notes: 'Σημειώσεις',
    table: 'Τραπέζι',
    capacity: 'Χωρητικότητα',
    tableName: 'Όνομα Τραπεζιού',
    tableShape: 'Σχήμα Τραπεζιού',
    searchGuests: 'Αναζήτηση καλεσμένων...',
    filterByTable: 'Φιλτράρισμα ανά τραπέζι',
    allTables: 'Όλα τα Τραπέζια',
    noTableAssigned: 'Χωρίς τραπέζι',
    // QR Code
    qrCode: 'Κωδικός QR',
    downloadQR: 'Λήψη Κωδικού QR',
    generateQR: 'Δημιουργία Κωδικού QR',
    qrGenerated: 'Ο κωδικός QR δημιουργήθηκε!',
    qrInstructions: 'Κατεβάστε αυτόν τον κωδικό QR και τοποθετήστε τον στις πινακίδες της εκδήλωσής σας ή εισάγετέ τον στο Canva.',
    publicLink: 'Δημόσιος Σύνδεσμος',
    qrColor: 'Χρώμα Κωδικού QR',
    customColor: 'Προσαρμοσμένο',
    noQRGenerated: 'Δεν έχει δημιουργηθεί κωδικός QR ακόμα',
    applying: 'Εφαρμογή',
    qrColorPremiumFeature: 'Η προσαρμογή χρώματος κωδικού QR είναι premium λειτουργία',
    upgradeToPremium: 'Αναβάθμιση σε Premium',
    // CSV
    csvFormat: 'Μορφή CSV: full_name, table_name, table_shape, seats, group_name, notes, personal_note',
    csvUploadHint: 'Συμβουλή: Η μεταφόρτωση ενημερώνει υπάρχοντες καλεσμένους (κατά όνομα) και προσθέτει νέους.',
    importSuccess: 'Η εισαγωγή ολοκληρώθηκε!',
    // Language
    language: 'Γλώσσα',
    english: 'English',
    portuguese: 'Português-PT',
    french: 'Français',
    spanish: 'Español',
    russian: 'Русский',
    italian: 'Italiano',
    greek: 'Ελληνικά',
    or: 'ή',
    signInWithGoogle: 'Σύνδεση με Google',
    // Actions
    edit: 'Επεξεργασία',
    back: 'Πίσω',
    logout: 'Αποσύνδεση',
    // Support Contact
    supportContact: 'Επικοινωνία Υποστήριξης',
    supportSubject: 'Θέμα',
    supportMessage: 'Μήνυμα',
    supportSubjectPlaceholder: 'Πώς μπορούμε να σας βοηθήσουμε;',
    supportMessagePlaceholder: 'Περιγράψτε την ερώτηση ή το πρόβλημά σας αναλυτικά...',
    supportSendMessage: 'Αποστολή Μηνύματος',
    supportSending: 'Αποστολή...',
    supportHelpText: 'Έχετε ερώτηση ή χρειάζεστε βοήθεια; Στείλτε μας μήνυμα και θα σας απαντήσουμε το συντομότερο δυνατό.',
    supportSuccess: 'Το αίτημα υποστήριξης στάλθηκε επιτυχώς!',
    supportError: 'Αποτυχία αποστολής αιτήματος υποστήριξης',
    supportValidationError: 'Παρακαλούμε συμπληρώστε το θέμα και το μήνυμα',
    // Upgrade & Pricing
    upgrade: 'Αναβάθμιση',
    upgradeEvent: 'Αναβάθμιση Εκδήλωσης',
    upgradeNow: 'Αναβάθμιση Τώρα',
    currentPlan: 'Τρέχον Πλάνο',
    current: 'Τρέχον',
    tryDaysFree: 'Δοκιμάστε {days} Ημέρες Δωρεάν',
    trialActive: 'Δοκιμαστική Περίοδος Ενεργή',
    trialUsed: 'Δοκιμή χρησιμοποιήθηκε',
    trial: 'Δοκιμή',
    viewFullPricing: 'Δείτε Πλήρη Τιμολόγηση & Χαρακτηριστικά',
    unlockPremiumFeatures: 'Ξεκλειδώστε premium χαρακτηριστικά για να κάνετε την εκδήλωσή σας αξέχαστη.',
    chooseYourPlan: 'Επιλέξτε το πλάνο που ταιριάζει στις ανάγκες σας.',
    // Plan Limit Messages
    planLimitReached: 'Έχετε φτάσει το όριο του πλάνου σας. Αναβαθμίστε για να συνεχίσετε.',
    planLimitGuests: 'Έχετε φτάσει το όριο καλεσμένων. Αναβαθμίστε για να προσθέσετε περισσότερους.',
    planLimitEventsFree: 'Έχετε φτάσει το όριο εκδηλώσεων. Αναβαθμίστε σε Pro για έως 3 εκδηλώσεις.',
    planLimitEventsPro: 'Έχετε φτάσει το μέγιστο των 3 εκδηλώσεων για το πλάνο Pro.',
    haveVoucher: 'Έχετε κωδικό κουπονιού;',
    enterVoucherCode: 'Εισάγετε κωδικό κουπονιού',
    apply: 'Εφαρμογή',
    selectPlanFirst: 'Επιλέξτε πρώτα πλάνο για να εφαρμόσετε το κουπόνι',
    voucherApplied: 'Το κουπόνι εφαρμόστηκε!',
    youSave: 'Εξοικονομείτε',
    featureComparison: 'Σύγκριση Χαρακτηριστικών',
    feature: 'Χαρακτηριστικό',
    maximumGuests: 'Μέγιστοι Καλεσμένοι',
    unlimited: 'Απεριόριστοι',
    colorThemes: 'Χρωματικά Θέματα',
    defaultOnly: 'Μόνο προεπιλογή',
    customMessages: 'Προσαρμοσμένα Μηνύματα',
    backgroundImages: 'Εικόνες Φόντου',
    customQrColor: 'Προσαρμοσμένο Χρώμα QR',
    presetThemes: 'Προκαθορισμένα Θέματα',
    allColorThemes: 'Όλα τα χρωματικά θέματα',
    upToEvents: 'Έως {count} εκδηλώσεις',
    oneEvent: '1 εκδήλωση',
    tax: 'Φόρος',
    total: 'Σύνολο',
    processing: 'Επεξεργασία...',
    free: 'Δωρεάν',
    premium: 'Premium',
    premiumPlus: 'Premium Plus',
    pro: 'Pro',
    freeDescription: 'Βασικές λειτουργίες για μικρές εκδηλώσεις',
    premiumDescription: 'Όλες οι λειτουργίες με απεριόριστους καλεσμένους',
    proDescription: 'Όλες οι λειτουργίες με απεριόριστους καλεσμένους και πολλές εκδηλώσεις',
    // Upgrade Popup
    premiumFeature: 'Premium Λειτουργία',
    premiumFeaturesRequired: 'Οι παρακάτω λειτουργίες απαιτούν πληρωμένο πλάνο για αποθήκευση:',
    customEventMessage: 'Προσαρμοσμένο Μήνυμα Εκδήλωσης',
    customColorTheme: 'Προσαρμοσμένο Χρωματικό Θέμα',
    customColorSettings: 'Προσαρμοσμένες Ρυθμίσεις Χρωμάτων',
    upgradeToUnlock: 'Αναβαθμίστε για να ξεκλειδώσετε αυτές τις λειτουργίες και να ξεχωρίσει η εκδήλωσή σας!',
    // Forgot Password & Legal
    forgotPassword: 'Ξεχάσατε τον κωδικό σας;',
    bySigningIn: 'Με τη σύνδεση, συμφωνείτε με τους',
    terms: 'Όρους',
    and: 'και',
    privacyPolicy: 'Πολιτική Απορρήτου',
    // Terms Page
    termsOfService: 'Όροι Χρήσης',
    termsLastUpdated: 'Τελευταία Ενημέρωση',
    termsIntro: 'Καλώς ήρθατε στο Digital Seating Chart. Με την πρόσβαση ή χρήση της υπηρεσίας μας, συμφωνείτε να δεσμεύεστε από αυτούς τους Όρους Χρήσης.',
    termsAcceptance: 'Αποδοχή Όρων',
    termsAcceptanceText: 'Με την πρόσβαση και χρήση του Digital Seating Chart, αποδέχεστε και συμφωνείτε να δεσμεύεστε από τους όρους και τις διατάξεις αυτής της συμφωνίας.',
    termsUseOfService: 'Χρήση της Υπηρεσίας',
    termsUseOfServiceText: 'Μπορείτε να χρησιμοποιήσετε την υπηρεσία μας μόνο για νόμιμους σκοπούς. Συμφωνείτε να μη χρησιμοποιείτε την υπηρεσία με τρόπο που παραβιάζει οποιουσδήποτε ισχύοντες νόμους ή κανονισμούς.',
    termsUserAccounts: 'Λογαριασμοί Χρηστών',
    termsUserAccountsText: 'Όταν δημιουργείτε λογαριασμό, πρέπει να παρέχετε ακριβείς και πλήρεις πληροφορίες. Είστε υπεύθυνοι για την προστασία των διαπιστευτηρίων του λογαριασμού σας.',
    termsIntellectualProperty: 'Πνευματική Ιδιοκτησία',
    termsIntellectualPropertyText: 'Η υπηρεσία και το πρωτότυπο περιεχόμενο, χαρακτηριστικά και λειτουργικότητα ανήκουν στο Digital Seating Chart και προστατεύονται από διεθνείς νόμους πνευματικών δικαιωμάτων και εμπορικών σημάτων.',
    termsTermination: 'Τερματισμός',
    termsTerminationText: 'Μπορούμε να τερματίσουμε ή να αναστείλουμε τον λογαριασμό σας αμέσως, χωρίς προηγούμενη ειδοποίηση ή ευθύνη, για οποιονδήποτε λόγο, συμπεριλαμβανομένης της παραβίασης αυτών των Όρων.',
    termsLimitation: 'Περιορισμός Ευθύνης',
    termsLimitationText: 'Σε καμία περίπτωση το Digital Seating Chart δεν θα είναι υπεύθυνο για τυχόν έμμεσες, τυχαίες, ειδικές, επακόλουθες ή τιμωρητικές ζημίες που προκύπτουν από τη χρήση της υπηρεσίας.',
    termsChanges: 'Αλλαγές στους Όρους',
    termsChangesText: 'Διατηρούμε το δικαίωμα να τροποποιήσουμε ή να αντικαταστήσουμε αυτούς τους Όρους ανά πάσα στιγμή. Θα σας ειδοποιήσουμε για τυχόν αλλαγές δημοσιεύοντας τους νέους Όρους σε αυτή τη σελίδα.',
    termsContact: 'Επικοινωνήστε μαζί μας',
    termsContactText: 'Εάν έχετε ερωτήσεις σχετικά με αυτούς τους Όρους, παρακαλούμε επικοινωνήστε μαζί μας.',
    // Privacy Page
    privacyPolicyTitle: 'Πολιτική Απορρήτου',
    privacyLastUpdated: 'Τελευταία Ενημέρωση',
    privacyIntro: 'Το απόρρητό σας είναι σημαντικό για εμάς. Αυτή η Πολιτική Απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τις πληροφορίες σας.',
    privacyDataCollection: 'Πληροφορίες που Συλλέγουμε',
    privacyDataCollectionText: 'Συλλέγουμε πληροφορίες που παρέχετε άμεσα, όπως το όνομά σας, τη διεύθυνση email και τις λεπτομέρειες της εκδήλωσης. Επίσης συλλέγουμε δεδομένα χρήσης για να βελτιώσουμε την υπηρεσία μας.',
    privacyDataUse: 'Πώς Χρησιμοποιούμε τις Πληροφορίες σας',
    privacyDataUseText: 'Χρησιμοποιούμε τις πληροφορίες σας για να παρέχουμε και να βελτιώσουμε τις υπηρεσίες μας, να επικοινωνούμε μαζί σας και να διασφαλίζουμε την ασφάλεια της πλατφόρμας μας.',
    privacyDataSharing: 'Κοινοποίηση Πληροφοριών',
    privacyDataSharingText: 'Δεν πουλάμε τις προσωπικές σας πληροφορίες. Ενδέχεται να μοιραστούμε δεδομένα με παρόχους υπηρεσιών που μας βοηθούν στη λειτουργία της πλατφόρμας μας.',
    privacyDataSecurity: 'Ασφάλεια Δεδομένων',
    privacyDataSecurityText: 'Εφαρμόζουμε κατάλληλα μέτρα ασφαλείας για να προστατεύσουμε τις προσωπικές σας πληροφορίες από μη εξουσιοδοτημένη πρόσβαση, τροποποίηση ή καταστροφή.',
    privacyUserRights: 'Τα Δικαιώματά σας',
    privacyUserRightsText: 'Έχετε το δικαίωμα πρόσβασης, διόρθωσης ή διαγραφής των προσωπικών σας δεδομένων. Μπορείτε να διαχειριστείτε τις πληροφορίες σας μέσω των ρυθμίσεων του λογαριασμού σας.',
    privacyCookies: 'Cookies',
    privacyCookiesText: 'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας. Μπορείτε να ελέγξετε τις ρυθμίσεις cookies μέσω των προτιμήσεων του προγράμματος περιήγησής σας.',
    privacyChanges: 'Αλλαγές σε αυτή την Πολιτική',
    privacyChangesText: 'Ενδέχεται να ενημερώσουμε αυτή την Πολιτική Απορρήτου κατά καιρούς. Θα σας ειδοποιήσουμε για τυχόν αλλαγές δημοσιεύοντας τη νέα πολιτική σε αυτή τη σελίδα.',
    privacyContact: 'Επικοινωνήστε μαζί μας',
    privacyContactText: 'Εάν έχετε ερωτήσεις σχετικά με αυτή την Πολιτική Απορρήτου, παρακαλούμε επικοινωνήστε μαζί μας.',
  }
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children, defaultLanguage = 'en' }) => {
  const [language, setLanguage] = useState(defaultLanguage);

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
